module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-selection-list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 large-6 columns"
  }, _vm._l((_vm.items), function(i, index) {
    return _c('div', {
      staticClass: "wrapper",
      on: {
        "click": function($event) {
          return _vm.selectItem(index)
        }
      }
    }, [_c(_vm.component, {
      tag: "component",
      attrs: {
        "item": i,
        "type": 'list'
      }
    })], 1)
  }), 0), _c('div', {
    staticClass: "small-12 large-6 columns"
  }, [_c(_vm.component, {
    tag: "component",
    attrs: {
      "item": _vm.selectedItem,
      "type": 'expanded'
    },
    on: {
      "updated": _vm.updated
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05d7f5b9!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/SelectionList.vue
// module id = 2223
// module chunks = 1